import {css} from "@emotion/react";
import styled from "@emotion/styled";


export const grid = css`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1em;
    grid-auto-rows: minmax(100px, auto);
`;

export const selectContainer = css`
    max-width: 400px;
`;

export const column = css`
    display: flex;
    flex-direction: column;
    height: 205px;
    flex: 1;
    align-items: center;
    justify-content: center;
`;
export const row = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    justify-content: center;

`;

export const total = css`
    margin-left: 10px;
    height: 30px;
    border-radius: 10px;
    background-color: #434864;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 8px;
    padding-right: 8px;
    margin: 5px;
`;

export const topFive = css`
    margin-left: 10px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 8px;
    padding-right: 8px;
    margin: 5px;
`;

export const textTotal = css`
    color: #FFFFFF;
    font-size: 24px;
    text-transform: uppercase;
    margin: 0;
`;

export const textTopFive = css`
    color: #434864;
    font-size: 24px;
    margin: 0;
`;

export const textTotalNumber = css`
    color: #449DF7;
    font-size: 100px;
    margin: 0;
`;

export const numberOfCallsText = css`
    color: #888888;
    font-size: 18px;
    width: 250px;
    text-align: center;
    margin: 9px;
`;

export const tFDisclaimer = css`
    padding-top: 20px;
    color: #888888;
    font-size: 16px;
    text-align: center;
`;

export const numberCard = css`
    color: #646464;
    font-size: 65px;
    padding-left: 20px;
`;

export const textStateCard = css`
    color: #888888;
    font-size: 16px;
    margin: 0;
    padding: 2px;
`;

export const pillBase = css`
    border-radius: 10px;
    height: 21px;
    padding-left: 6px;
    padding-right: 6px;
    color: #FFFFFF;
    font-size: 13px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: -0.5px;
`;

export const bluePill = css`
    background-color: #3F90E3;
`;

export const fixedWidth = css`
    width: 100px;
    padding-bottom: 5px;
`;

export const greenPill = css`
    background-color: #2FB7AC;
`;

export const yellowGreenPill = css`
    background-color: #6CB91F;
`;

export const orangePill = css`
    background-color: #FF9300;
`;

export const textStateContainer = css`
    width: 100px;

`;

export const move = css`
    float: right;
`;

export const LineMark = styled.div`
    width: 100%;
    margin: 15px auto;
    height: 1px;
    background: #9B9B9B;
`;


export const columnModal = css`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: flex-start;
`;

export const columnModalLeft = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 200px;
    max-width: 200px;
    word-break: break-word;
    margin-right: 48px;
`;

export const columnModalFull = css`
    display: flex;
    flex-direction: row;
    align-self: center;
    min-width: 200px;
    max-width: 200px;
    word-break: break-word;
    margin-right: 48px;
`;

export const columnModalLeftMult = css`
    display: flex;
    flex-direction: row;
    align-self: center;
    min-width: 20px;
    padding-right: 25px;
`;

export const columnModalRight = css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex: 1;
`;

export const rowModal = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: flex-start;
`;

export const notCentered = css`
    align-self: flex-start;
`;

export const multiRowModal = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
`;


export const columnModalRightStacked = css`
    display: flex;
    flex-direction: column;
    flex: 1;
`;


export const modalSubtitle = css`
    margin: 0;
    margin-left: 10px;
`;

export const modalSubtitleDetails = css`
    margin: 0;
    margin-left: 10px;
`;

export const modalMapHeight = css`
    width: 500px;
    height: 300px;
`;

export const modalTextDescription = css`
    font-weight: normal;
    margin: 0;
    padding-right:10px;
`;

export const modalTextArea = css`
    font-weight: normal;
    margin: 0;
`;

export const styleMenWithHeadphones = css`
    background-color: #F7FBFF;
`;

export const rowTitle = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
`;

export const columnTitle = css`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: flex-start;
    justify-content: center;
`;
export const columnTitleEnd = css`
    align-items: flex-end;
    display: flex;
`;

export const columnElement = css`
    display: flex;
    flex-direction: column;
    flex: 0;
    align-items: flex-start;
    justify-content: center;
`;

export const tFHead = css`
    padding: 5px;
    padding-top:20px;
    border-bottom: 2px solid #434864
`;

export const tFHeadText = css`
    display: inline-block;
    color: #449DF7;
    height: 10px;
    width: 140px;
    text-align: center;
`;

export const tFRow = css`
    padding: 5px;
`;

export const tFMineText = css`
    display: inline-block;
    font-size: 14px;
    width: 140px;
    height: 10px;
    text-align: center;
`;

export const tFMineTextLink = css`
    display: inline-block;
    color: #449DF7;
    text-decoration: underline;
    font-size: 14px;
    width: 140px;
    height: 10px;
    text-align: center;
    cursor: pointer;
`;

export const allTrains = css`
    max-width: 400px;
    text-align: center;
`;

export const allTrainsText = css`
    display: inline-block;
    padding-right: 4px;
    vertical-align: super;
`;

export const nsCarDiv = css`
    margin-top: 30px;
    margin-bottom: 20px;
`;

